export default __webpack_public_path__ + "static/media/i.a1b39f05.png";